import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { RegisterForm } from "@/types";

const endpoint = {
  establishment: "/establishment",
};

export const registerEstablishment = createAsyncThunk(
  "establishment/register",
  async (userData: Omit<RegisterForm, "confirmPassword">, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.establishment, {
        name: userData.name,
        email: userData.email,
        password: userData.password,
        password_confirmation: userData.password_confirmation,
        phone_whatsapp: userData.phone_whatsapp,
        plan_id: userData.plan_id,
        origin_country: (userData as any).origin_country,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updateEstablishment = createAsyncThunk(
  "establishment/update",
  async (data: any, thunkAPI) => {
    try {
      const hasFile =
        typeof FormData !== "undefined" &&
        (data instanceof FormData || data?.logo_image instanceof File);
      let payload = data;
      // IMPORTANTE: baseURL já vem como {API_URL}/establishment/{slug}
      // portanto não devemos concatenar novamente '/establishment' senão gera
      // /establishment/{slug}/establishment (404). Usar raiz ('').
      const url = "";

      if (hasFile) {
        const fd = data instanceof FormData ? data : new FormData();
        if (!(data instanceof FormData)) {
          Object.entries(data || {}).forEach(([k, v]) => {
            if (v === undefined || v === null) return;
            if (v instanceof File) {
              fd.append(k, v);
            } else if (typeof v !== "object") {
              fd.append(k, String(v));
            }
          });
        }
        // method override (mantém padrão usado em outros módulos)
        fd.append("_method", "PUT");
        payload = fd;
        const response = await axiosInstance.post(url, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
      }

      const response = await axiosInstance.put(url, payload);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const resetPasswordEstablishment = createAsyncThunk(
  "establishment/reset-password",
  async (email: { email: string }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/send-password-reset", email);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        // Captura a mensagem de erro específica da API
        const errorData = error.response?.data as any;
        const errorMessage =
          errorData?.message ||
          errorData?.error ||
          error.message ||
          "Erro ao enviar e-mail de recuperação";
        return thunkAPI.rejectWithValue({ error: errorMessage });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro inesperado ao enviar e-mail",
        });
      }
    }
  },
);
